import { useAuthAmoSyncDataMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useAmoSyncData = () => {
  const [mutation, mutationResult] = useAuthAmoSyncDataMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (companyId: string) => {
    const mutationResult = await mutation({
      variables: {
        input: {
          companyId,
        },
      },
    });

    return !!mutationResult.data?.amoSyncData?.ok;
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default useAmoSyncData;
